document.addEventListener('DOMContentLoaded', function () {
  const customElement = document.querySelector('section-sticky-toc');

  if (customElement) {
    const parentElement = customElement.parentElement;

    // Initialize lastScrollY to track scroll direction
    let lastScrollY = window.scrollY;

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Add scroll event listener
    window.addEventListener('scroll', function () {
      const currentScrollY = window.scrollY;
      if (currentScrollY < lastScrollY) {
        parentElement.style.top = '124px'; // Adjust parent element
      } else {
        parentElement.style.top = '0px'; // Adjust parent element
      }

      if (prefersReducedMotion) {
        parentElement.style.transition = 'none'; // Disable transition for reduced motion
      }
      // Update lastScrollY
      lastScrollY = currentScrollY;
    });
  } else {
    console.error('Custom element not found');
  }
});
